export default "__VITE_ASSET__Os_aBXhe__"